import { Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";

export default function AdminProtected() {
  const { user, loading } = useAdminAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-[#B8B8B8]">Carregando…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
